import { useCallback, useMemo } from "react"
import { flatten } from "shared/util"

import { Dialog, DialogContent } from "@mui/material"

import { ErrorBlock } from "components/controls/errorInfo"
import { Loading } from "components/controls/loading"

import { useGetCurrentAgreement, usePostAgree } from "interface/agreement"
import { AgreementPreview } from "../components/preview"

type AgreementPreviewDialogProps = {
  onAgree: (version: number) => void
  onClose: () => void
}
export const AgreementPreviewDialog = ({
  onAgree,
  onClose
}: AgreementPreviewDialogProps) => {
  const getState = useGetCurrentAgreement()
  const agreement = useMemo(() => getState.data, [getState])
  const [agreeState, agree] = usePostAgree({ onPosted: () => onAgree(agreement?.version ?? 0) })

  const onClickAgree = useCallback(
    () => {
      if (!agreement) return
      agree(agreement.version)
    },
    [agree, agreement]
  )
  return (
    <Dialog
      open
      fullWidth
      maxWidth='md'
      onClose={() => onClose()}
    >
      <DialogContent
        sx={{
          padding: 0,
          height: '80vh',
          position: 'relative'
        }}
      >
        {(getState.loading || agreeState.posting) && <Loading/>}
        <ErrorBlock error={flatten([getState.error, agreeState.error])}/>

        {agreement && (
          <AgreementPreview
            agreement={agreement}
            onClickAgree={onClickAgree}
            onClose={onClose}
            height="100%"
          />
        )}
      </DialogContent>
    </Dialog>
  )
}